var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vw-100 vh-100"},[_c('div',{staticClass:"d-flex justify-content-center align-items-center vh-100"},[_c('div',{staticClass:"alert alert-danger"},[_c('p',[_vm._v("SESION EXPIRADA")])])])])
}]

export { render, staticRenderFns }